import { JsonEditor } from 'jsoneditor-react/es';
import React from 'react';

export default function DataEditor(props) {
    if (props.data) {
        const styleObj = props.style ? props.style : { height: '70vh', width: '780px', marginLeft: '80px' };
        return (
            <>
                <JsonEditor
                    htmlElementProps={{ style: styleObj }}
                    value={props.data}
                    onChange={(event) => props.handleUpdate(event)}
                    // TODO: Figure out a way to disable editing in read-only mode.
                    mode="code"
                    allowedModes={props.readOnly ? ['view', 'code'] : ['tree', 'code']}
                />
            </>
        );
    }
    return <p>Loading...</p>;
}
